import { ProfilePhotoContainer } from "./style";

type CoverImageProps = {
  image_path: string;
  link: string;
};

const ProfilePhoto: React.FC<CoverImageProps> = ({ image_path, link }) => {
  return (
    <ProfilePhotoContainer>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={image_path} alt="Foto de perfil" />
      </a>
    </ProfilePhotoContainer>
  );
};

export { ProfilePhoto };
